import PropTypes from 'prop-types';

const UtlityNavigationHeading = ({ children }) => (
  <div className="flex-1 text-gray-5">{children}</div>
);

UtlityNavigationHeading.propTypes = {
  children: PropTypes.node.isRequired,
};

export default UtlityNavigationHeading;
